var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useContext, useState } from 'react';
// @ts-ignore
import Dropzone from 'react-dropzone';
import { Box, CircularProgress, Button, TextField, Typography, } from '@kareo/design-system';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import rollbar from 'shared-assets/src/errors/errors';
import ModalCard from 'shared-assets/components/Modal/ModalCard';
import { PatientContext } from 'shared-assets/facesheet-ui/components/Facesheet/Container/Facesheet';
import { formatFileName, formatPatientName, } from 'shared-assets/facesheet-ui/utils/patientHelper';
import { uploadSummaryOfCare } from 'shared-assets/facesheet-ui/service/legacy/service';
import { useSnackbar } from 'notistack';
import { SUMMARY_OF_CARE_ALERT } from 'shared-assets/facesheet-ui/service/legacy/types';
var StyledTextField = styled(TextField)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && input {\n    padding: 18.5px 18px;\n  }\n  && label {\n    background-color: white;\n  }\n"], ["\n  && input {\n    padding: 18.5px 18px;\n  }\n  && label {\n    background-color: white;\n  }\n"])));
var StyledDropzone = styled(Dropzone)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: none;\n"], ["\n  border: none;\n"])));
var ImportSummaryOfCare = function (_a) {
    var patientId = _a.patientId, isModalOpen = _a.isModalOpen, closeSOCModal = _a.closeSOCModal;
    var patient = useContext(PatientContext);
    var dropzoneRef;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), file = _c[0], setFile = _c[1];
    var _d = useState(''), fileName = _d[0], setFileName = _d[1];
    var _e = useState(''), documentName = _e[0], setDocumentName = _e[1];
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var onDrop = useCallback(function (acceptedFiles) {
        if (acceptedFiles.length > 0) {
            var file_1 = acceptedFiles[0];
            setFileName(file_1.name);
            setFile(file_1);
            if (!documentName) {
                setDocumentName(formatFileName(file_1.name));
            }
        }
    }, [file]);
    var uploadFile = function (patientId) {
        if (file) {
            setLoading(true);
            var formData = new FormData();
            formData.append('patientId', "" + patientId);
            formData.append('documentName', documentName);
            formData.append('fromRor', '0');
            formData.append('file', file);
            uploadSummaryOfCare(formData)
                .then(function (res) {
                if (res.ok) {
                    enqueueSnackbar(SUMMARY_OF_CARE_ALERT.success, {
                        variant: 'success',
                    });
                    setLoading(false);
                    closeSOCModal();
                }
                else {
                    enqueueSnackbar(SUMMARY_OF_CARE_ALERT.error, {
                        variant: 'error',
                    });
                    setLoading(false);
                }
            })
                .catch(function (e) {
                enqueueSnackbar(SUMMARY_OF_CARE_ALERT.error, {
                    variant: 'error',
                });
                setLoading(false);
                rollbar.error(e);
            });
        }
    };
    return (React.createElement(ModalCard, { open: isModalOpen, header: "Import Summary of Care", footer: React.createElement(Grid, { container: true, direction: "row-reverse" },
            React.createElement(Grid, { item: true }, loading ? (React.createElement(CircularProgress, { size: 25, color: "primary" })) : (React.createElement("div", null,
                React.createElement(Button, { variant: "text", size: "small", color: "vitality", onClick: closeSOCModal },
                    React.createElement(Typography, { component: "div" }, "Cancel")),
                React.createElement(Button, { color: "vitality", size: "small", onClick: function () { return uploadFile(patientId); }, disabled: !documentName || !file },
                    React.createElement(Typography, { component: "div" }, "Upload")))))), onClose: closeSOCModal },
        React.createElement(Box, { display: "flex" },
            React.createElement(Grid, { container: true, direction: "column", spacing: 2 },
                React.createElement(Grid, { item: true, container: true, spacing: 2, alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Typography, { component: "div" }, "Choose XML file")),
                    React.createElement(Grid, { item: true },
                        React.createElement(StyledDropzone, { accept: ".xml", multiple: false, onDrop: onDrop, ref: function (node) {
                                dropzoneRef = node;
                            } },
                            React.createElement(Button, { color: "vitality", size: "small" },
                                React.createElement(Typography, { component: "div" }, "Browse")))),
                    fileName && (React.createElement(Grid, { item: true },
                        React.createElement(Typography, { component: "div" }, fileName)))),
                React.createElement(Grid, { item: true },
                    React.createElement(StyledTextField, { required: true, label: "Document Name", value: documentName, onChange: function (event) {
                            setDocumentName(event.target.value);
                        }, inputProps: { maxLength: 50 } })),
                React.createElement(Grid, { item: true }, patient && (React.createElement(Typography, { component: "div" }, "Confirm this file is for " + formatPatientName(patient))))))));
};
export default ImportSummaryOfCare;
var templateObject_1, templateObject_2;
